/**
Project: Phone Connect (c)
Title: Page Loader
Description: Component for displaying page loading spinner
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";

class PageLoader extends Component {
  render() {
    if (this.props.status) {
      // data load status is true
      return this.props.children;
    } else {
      // data load status is false
      let size = "medium";
      let spinnerSize = SpinnerSize.medium;
      if (this.props.size) {
        size = this.props.size;
        switch (size) {
          case "tiny":
            spinnerSize = SpinnerSize.xSmall;
            break;
          case "small":
            spinnerSize = SpinnerSize.small;
            break;
          case "medium":
            spinnerSize = SpinnerSize.medium;
            break;
          case "large":
            spinnerSize = SpinnerSize.large;
            break;
          default:
            spinnerSize = SpinnerSize.medium;
            break;
        }
      }
      let label = null;
      if (this.props.label) {
        label = this.props.label;
      }
      let labelPosition = null;
      if (this.props.label) {
        labelPosition = this.props.labelPosition; // top, bottom, left, right
      }
      let type = "inline";
      if (this.props.type) {
        type = this.props.type;
      }
      let typeClassName = "";
      if (type === "inline") {
        typeClassName = "page-loader-wrapper-inline";
      } else if (type === "full") {
        typeClassName = "page-loader-wrapper-full";
      } else if (type === "center") {
        typeClassName = "page-loader-wrapper-center";
      } else if (type === "frame") {
        typeClassName = "page-loader-wrapper-frame";
      } else if (type === "middle") {
        typeClassName = "page-loader-wrapper-middle";
      }

      return (
        <div className={typeClassName}>
          <div className="page-loader-spinner-box">
            <Spinner
              size={spinnerSize}
              label={label}
              labelPosition={labelPosition}
              ariaLive="assertive"
              className={`page-loader-spinner-${size}`}
            />
          </div>
        </div>
      );
    }
  }
}

export default PageLoader;
